import { NgModule } from "@angular/core";
import { MedIconHomeModule } from "@mk/med-icons";

import { BreadcrumbsComponent } from "./breadcrumbs.component";
import { RouterLink } from "@angular/router";
import { MedBreadcrumbModule, MedDirectiveSharedModule } from "@mk/med-ui";

@NgModule({
  declarations: [BreadcrumbsComponent],
  imports: [MedIconHomeModule, RouterLink, MedBreadcrumbModule, MedDirectiveSharedModule],
  exports: [BreadcrumbsComponent],
})
export class BreadcrumbsModule {}
